export default "__VITE_ASSET__CJ08IfhD__"